var _defs, _path, _path2, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGyeongWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 255.83 141.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#eb1d47;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M187.05,548.36a74.95,74.95,0,0,1-63.88-113.89l26.09,16.23a44.2,44.2,0,0,0,75.05,46.7l26.1,16.23a74.44,74.44,0,0,1-46.22,32.75A76,76,0,0,1,187.05,548.36Z",
    transform: "translate(-112.23 -406.73)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M331,504.39a44.2,44.2,0,0,0-75-46.7l-26.1-16.23a74.44,74.44,0,0,1,46.22-32.75,76,76,0,0,1,17.14-2,74.95,74.95,0,0,1,63.88,113.89Z",
    transform: "translate(-112.23 -406.73)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "88.42 63.9 68.25 95.85 44.34 80.76 79.6 24.9 164.22 78.3 184.39 46.35 208.3 61.44 173.05 117.3 88.42 63.9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGyeongWhite);
export default __webpack_public_path__ + "static/media/gyeong_white.b43e9fb190678bd1c82c2de9213ae6f3.svg";
export { ForwardRef as ReactComponent };